import React, { useState, useEffect } from 'react';
import { Groupper, Pagination, Toast, Header } from 'react-frontier';
import { Divider, Rating } from 'semantic-ui-react';
import { WorkerRating } from '../SiteClasses';
import API from '../API';
import moment from 'moment';

interface WorkerRatingsProps{
	workerId: number,
	style: React.CSSProperties,
}

const PAGE_SIZE = 5;

var WorkerRatings = (props: WorkerRatingsProps)=>{
	var [ratings, setRatings] = useState<WorkerRating[]>([]);
	var [loading, setLoading] = useState<boolean>(true);
	var [page, setPage] = useState<number>(0);

	useEffect(()=>{
		getRatings();
	}, [props.workerId]);

	var getRatings = (get_page?: number)=>{
		var offset = (get_page > 0) ? Math.max(0, (get_page || page) * PAGE_SIZE) : 0;
		
		setLoading(true);
		API.getWorkerRatings(props.workerId, PAGE_SIZE, offset).then(res=>{
			if(res.error) return Toast.error(res.message);
			setRatings(res.data);
		}).catch(err=>{
			Toast.error('Hubo un error cargando las calificaciones (LCL-1)');
		}).finally(()=>{
			setLoading(false);
		});
	};

	var onPageChange = (page: number)=>{
		setLoading(true);
		setPage(page);
		getRatings(page);
	};

	var ratingsWithComments = ratings.filter((r: WorkerRating) => r.rating_comment && r.rating_comment.trim());
	
	return <Groupper className='op reviews' title={`Calificaciones`} width={500} style={props.style} fitted>
		<div className="list">
			{loading ? (
				<Header text={'Cargando datos...'} loading />
			) : (
				ratingsWithComments.map((i, ix, arr)=><>
					<div className="rating" key={`USR-RTG${i.date_id}-${i.user_rated}`}>
						<div className="header">
							<div className="info">
								<div className="top">
									<div className="stars">
										<Rating rating={i.rating} maxRating={5} disabled size='small' icon='star' />
									</div>
									<div className="user">
										{i.user_rated_name}
									</div>
								</div>
								{i.event_name && (
									<div className="event">
										{i.event_name}
									</div>
								)}
							</div>
							<div className="date">
								{moment.unix(i.date_rated).format('DD/MM/YY HH:mm')}
							</div>
						</div>
						<div className="comment">
							{i.rating_comment}
						</div>
					</div>
					{ix<arr.length && (
						<Groupper.Divider />
					)}
				</>)
			)}
			{ratingsWithComments.length === 0 && !loading && (
				<div className="empty">No hay calificaciones con comentarios para mostrar. </div>
			)}
		</div>
		<div className="actions">
			{ratingsWithComments.length > 0 && (
				<div style={{ padding: 5, textAlign: 'right' }}>
					<Pagination page={page} onPageChange={onPageChange} hasNext={ratings.length>=PAGE_SIZE} />
				</div>
			)}
		</div>
	</Groupper>
};

export default WorkerRatings;